import { css } from '@emotion/core';
import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const styledVideoHeroSection = css`
  background: #031b43;
  margin-top: 106px;
  padding: 0;
  height: 750px;

  ${media('<desktop')} {
    margin-top: -65px;
    height: auto;
  }

  video::-webkit-media-controls-start-playback-button {
    display: none;
  }
`;

export const styledVideoHeroFullscreen = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`;

export const styledVideoHero = css`
  z-index: 3;
  position: relative;
  height: 750px;

  ${media('<tablet')} {
    height: auto;
  }

  div.hero-body {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;

    p.subtitle {
      margin-bottom: 40px;
      max-width: 470px;
      font-size: 24px;
      line-height: 150%;
      margin-top: 20px;
      margin-left: 0;
    }

    .buttons {
      justify-content: center;
      margin-bottom: 0px;

      .button-link {
        margin-right: 20px;
      }

      .button-link:nth-of-type(2) {
        margin-right: 0px !important;
      }
    }
  }
`;

export const styledButtonContainer = css`
  margin-top: 32px;
`;

export const StyledVideoPlay = styled.div`
  display: flex;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 32px;
  justify-content: center;

  &:hover {
    transform: scale(1.04);
  }

  figure {
    width: 20px;
    height: 20px;
    margin: 0 4px 0 0;
  }

  p {
    font-size: 0.75em;
    line-height: 2em;
    margin: 0 2px;
    display: inline-block;
  }
`;

export const styledModal = css`
  margin: auto;
  border-radius: 3px;
  max-width: 80%;

  ${media('<desktop')} {
    max-width: 95%;
  }

  div:only-child {
    margin: 0 auto;
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }
`;

export const StyledVideoContainer = styled.div`
  position: absolute;
  border-radius: 5px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  opacity: 0.6;
  height: 750px;
`;

export const StyledBackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  overflow: hidden;
  height: 750px;
  width: 100%;
  object-fit: cover;
`;

export const styledHeroBox = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 370px;
  margin: 0;
  border-radius: 6px;

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 220px;
    text-align: center;
    padding: 32px;
  }

  ${media('<desktop')} {
    min-width: 320px;
    max-width: 370px;
    margin-top: 32px;
  }
`;

export const styledHeroBoxTitle = css`
  flex: 0 !important;
  width: 100%;
  justify-content: center;
  border-radius: 6px 6px 0px 0px;
  background-color: #f3f5f9;
  padding: 16px 0 12px 0;

  h5 {
    margin-top: 0px;
    display: flex;
    align-items: center;
    height: 36px;
  }
`;

export const StyledForm = styled.form`
  .form-wrapper {
    display: inline-block;
    text-align: left;
  }

  .hide-error {
    display: none;
  }

  .show-error {
    display: block;
  }

  input {
    width: 100%;
    height: 48px;
    border: 1px solid #e5e8ed;
    box-sizing: border-box;
    border-radius: 3px;
    margin-bottom: 8px;

    font-family: 'WorkSans-Regular';
    font-size: 16px;
    padding: 16px;
    color: #031b4e;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    :focus {
      border-color: #0069ff;
      outline: #0069ff;
    }
  }

  input.error-border {
    border: solid 1px #ca0c0c;
  }

  input[type='submit'] {
    background: #0069ff;
    border: none;
    line-height: 100%;
    font-family: 'WorkSans-Bold';
    color: #fff;
    padding: 17px;
    cursor: pointer;
    margin-bottom: 0;
  }

  span.error-text {
    color: #ca0c0c;
    display: inline-block;
    font-family: 'WorkSans-Regular';
    font-size: 12px;
    margin-bottom: 16px;
    text-align: left;
  }
`;

export const styledSubmit = css`
  width: 100%;
`;

export const StyledButtonsContainer = styled.div`
  border-top: 1px solid #f3f5f9;
  width: 306px;
  padding: 32px;
  display: flex;
  justify-content: space-between;
`;

export const StyledSubscript = styled.div`
  p,
  a {
    font-family: 'WorkSans-Regular';
    font-size: 12px;
    text-align: center;
    color: #fff;
  }

  a:hover {
    color: white !important;
    border-bottom: dotted 1px rgba(255, 255, 255, 0.5);
  }
`;

export const VideoContentFormWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: left;

  ${media('<tablet')} {
    flex-wrap: wrap;
    text-align: center;
  }
`;

export const videoContentContainer = css`
  width: 48%;
  text-align: left;
  padding-left: 90px;

  h1 {
    margin-top: -100px;
    text-align: left;
  }

  #testVideoPlayButton {
    justify-content: left;
  }

  ${media('<tablet')} {
    width: 100%;
    margin-right: 0;

    h1 {
      margin-top: 0;
    }
    #testVideoPlayButton {
      justify-content: center;
    }
  }
`;

export const videoContentBusinessContainer = css`
  width: 100%;
  text-align: center;
`;

export const VideoFormContainer = styled.div`
  width: 50%;
  text-align: center;

  .videoFormWrapper {
    display: inline-block;
    max-width: 370px;
  }

  ${media('<tablet')} {
    width: 100%;
    margin: 0 auto;
  }
`;
